"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackRequestToJoinPrivateGroup = trackRequestToJoinPrivateGroup;

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var EVENT_NAME = 'userevent';
var EVENT_SOURCE = 'control'; // mixpanel-forwarder is ignoring any other type of event

function trackRequestToJoinPrivateGroup(origin, groupId) {
  _publish.default.trackEvent(EVENT_NAME, {
    event_source: EVENT_SOURCE,
    type: 'Request to join a private group',
    origin: origin,
    groupId: groupId
  });
}